export default function AddressEmpty() {
  return (
    <div className="flex flex-col items-center justify-center w-full h-16">
      <h1 className="text-lg font-semibold">
        - Nebyly nalezeny žádné adresy -
      </h1>
    </div>
  )
}
